"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouteOrderByField = exports.SORT_VALUE = exports.RunStatusFilterOptions = exports.PlannedTasksFilterOptions = exports.UnassignedFilterOptions = exports.ReadyForPickupFilterOptions = exports.GroupMode = void 0;
var GroupMode;
(function (GroupMode) {
    GroupMode["Driver"] = "Driver";
    GroupMode["Fleet"] = "Fleet";
    GroupMode["FleetTeam"] = "FleetTeam";
    GroupMode["None"] = "None";
    GroupMode["Route"] = "Route";
    GroupMode["Team"] = "Team";
    GroupMode["TeamDriver"] = "TeamDriver";
    GroupMode["TeamRoute"] = "TeamRoute";
})(GroupMode || (exports.GroupMode = GroupMode = {}));
var ReadyForPickupFilterOptions;
(function (ReadyForPickupFilterOptions) {
    ReadyForPickupFilterOptions[ReadyForPickupFilterOptions["NOT_READY_FOR_PICKUP"] = 1] = "NOT_READY_FOR_PICKUP";
    ReadyForPickupFilterOptions[ReadyForPickupFilterOptions["READY_FOR_PICKUP"] = 2] = "READY_FOR_PICKUP";
})(ReadyForPickupFilterOptions || (exports.ReadyForPickupFilterOptions = ReadyForPickupFilterOptions = {}));
var UnassignedFilterOptions;
(function (UnassignedFilterOptions) {
    UnassignedFilterOptions[UnassignedFilterOptions["UNASSIGNED_TASKS"] = 0] = "UNASSIGNED_TASKS";
    UnassignedFilterOptions[UnassignedFilterOptions["ASSIGNED_TASKS"] = 1] = "ASSIGNED_TASKS";
})(UnassignedFilterOptions || (exports.UnassignedFilterOptions = UnassignedFilterOptions = {}));
var PlannedTasksFilterOptions;
(function (PlannedTasksFilterOptions) {
    PlannedTasksFilterOptions[PlannedTasksFilterOptions["UNPLANNED_TASKS"] = 0] = "UNPLANNED_TASKS";
    PlannedTasksFilterOptions[PlannedTasksFilterOptions["PLANNED_TASKS"] = 1] = "PLANNED_TASKS";
})(PlannedTasksFilterOptions || (exports.PlannedTasksFilterOptions = PlannedTasksFilterOptions = {}));
var RunStatusFilterOptions;
(function (RunStatusFilterOptions) {
    RunStatusFilterOptions[RunStatusFilterOptions["OPEN"] = 1] = "OPEN";
    RunStatusFilterOptions[RunStatusFilterOptions["CLOSE"] = 2] = "CLOSE";
})(RunStatusFilterOptions || (exports.RunStatusFilterOptions = RunStatusFilterOptions = {}));
exports.SORT_VALUE = 'sort_value';
var RouteOrderByField;
(function (RouteOrderByField) {
    RouteOrderByField["Name"] = "Name";
    RouteOrderByField["StartTime"] = "StartTime";
})(RouteOrderByField || (exports.RouteOrderByField = RouteOrderByField = {}));
//# sourceMappingURL=index.js.map